import { SxProps, Box, Typography } from '@mui/material';
import { ReactElement } from 'react';

const titleStyle: SxProps = {
  color: 'customGrey.dark',
  fontSize: '30px',
  fontWeight: '400'
};

type Props = {
  containerSx?: SxProps;
  title: string;
  titleSx?: SxProps;
  subTitle?: string | ReactElement;
};

/** @deprecated use TextBlock as that matches better with figma */
export const SectionHeader: React.FC<Props> = ({
  containerSx,
  title,
  subTitle,
  titleSx
}) => {
  return (
    <Box sx={{ maxWidth: '700px', ...containerSx }}>
      <Typography sx={{ ...titleStyle, ...titleSx }}>{title}</Typography>
      {subTitle && typeof subTitle === 'string' && (
        <Typography
          variant="body1"
          color="customGrey.dark"
          whiteSpace="pre-wrap"
          mt={1}
        >
          {subTitle}
        </Typography>
      )}
      {subTitle && typeof subTitle !== 'string' && subTitle}
    </Box>
  );
};
